module.exports = __webpack_public_path__ + "static/media/image_QR code_wap.dbcc2083.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/about/image_QR code_wap.png
// module id = 688
// module chunks = 0